<template>
  <div class="detail-main-page">
    <main-header :hasBanner="true"></main-header>
    <section class="main-center list-clr">
      <list-left :type="'jggs'"></list-left>
      <div class="page-right">
        <div class="info-top">
          <div class="info-title">{{obj.name}}</div>
          <div class="info-desc">
            {{obj.address}}
          </div>
          <div class="lab-item">
            <div class="lab-left">备案证书编号：</div>
            <div class="lab-right">{{obj.certificateNo}}</div>
          </div>
          <div class="lab-item">
            <div class="lab-left">统一社会信用代码：</div>
            <div class="lab-right">{{obj.creditCode}}</div>
          </div>
          <div class="lab-item">
            <div class="lab-left">门店数量：</div>
            <div class="lab-right">{{obj.storeNum}}</div>
          </div>
        </div>
        <div class="info-bottom">
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">区县：</div>
              <div class="lab-right">{{obj.districtName}}</div>
            </div>
            <div class="lab-item">
              <div class="lab-left">工商注册时间：</div>
              <div class="lab-right">{{obj.foundedDate}}</div>
            </div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">营业执照有效期：</div>
              <div class="lab-right"></div>
            </div>
            <div class="lab-item">
              <div class="lab-left">经营范围：</div>
              <div class="lab-right">{{obj.businessScope}}</div>
            </div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">企业类型：</div>
              <div class="lab-right"></div>
            </div>
            <div class="lab-item">
              <div class="lab-left">注册资本：</div>
              <div class="lab-right">{{obj.registeredCapital}} <span v-if="obj.registeredCapital">万元</span></div>
            </div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">法人代表：</div>
              <div class="lab-right">{{obj.charge}}</div>
            </div>
            <div class="lab-item">
              <div class="lab-left">电子邮件：</div>
              <div class="lab-right"></div>
            </div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">联系人：</div>
              <div class="lab-right">{{obj.contacts}}</div>
            </div>
            <div class="lab-item">
              <div class="lab-left">联系电话：</div>
              <div class="lab-right">{{obj.contactsPhone}}</div>
            </div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">企业地址：</div>
              <div class="lab-right">
                {{obj.address}}
              </div>
            </div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">企业简介：</div>
              <div class="lab-right">
                {{obj.profile}}
              </div>
            </div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">企业诚信码：</div>
              <div class="lab-right">
                <vue-qr
                  :text="mbCode"
                  :size="115"
                  :margin="0"
                ></vue-qr>
              </div>
            </div>
            <div class="lab-item">
              <div class="look-remark" @click="goRemark">查看评价</div>
            </div>
          </div>
        </div>


       <div class="i-r-t">门店列表</div>
        <el-table stripe :data="obj && obj.storeList || []" border style="width: 100%">
          <el-table-column
            align="centet"
            header-align="center"
            prop="name"
            label="门店名称"
          ></el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="address"
            label="门店地址"
          >
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="charge"
            label="联系人"
          >
          </el-table-column>
          <el-table-column align="centet" header-align="center" label="详细">
            <template slot-scope="scope">
              <img
                @click="goStoreDetail(scope.row)"
                style="width: 20px; cursor: pointer"
                src="@/assets/img/search.png"
                alt=""
              />
            </template>
          </el-table-column>
        </el-table>



        <div class="i-r-t">机构人员</div>
        <el-table stripe :data="pList" border style="width: 100%">
          <el-table-column
            align="centet"
            header-align="center"
            prop="name"
            label="姓名"
          ></el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="phoneNo"
            label="联系电话"
          >
          </el-table-column>
           <el-table-column
            align="centet"
            header-align="center"
            prop="code"
            label="从业编码"
            width="160"
          >
          </el-table-column>
          <el-table-column align="centet" header-align="center" label="详细">
            <template slot-scope="scope">
              <img
                @click="goDetail(scope.row)"
                style="width: 20px; cursor: pointer"
                src="@/assets/img/search.png"
                alt=""
              />
            </template>
          </el-table-column>
        </el-table>

        <div class="i-r-t">基础积分</div>
        <el-table stripe :data="obj.basePoint && [obj.basePoint] || []" border style="width: 100%">
          <el-table-column
            align="centet"
            header-align="center"
            prop="title"
            label="积分名称"
          ></el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="date"
            label="积分日期"
          >
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="totalPoint"
            label="积分分值"
          >
          </el-table-column>
        </el-table>

        <div class="i-r-t">良好行为记录</div>
        <el-table stripe :data="goodList" border style="width: 100%">
          <el-table-column
            align="centet"
            header-align="center"
            prop="title"
            label="获奖名称"
          ></el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="recordDate"
            label="获奖日期"
          >
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="points"
            label="积分分值"
          >
          </el-table-column>
        </el-table>

        <div class="i-r-t">不良行为记录</div>
        <el-table stripe :data="badList" border style="width: 100%">
          <el-table-column
            align="centet"
            header-align="center"
            prop="title"
            label="违规名称"
          ></el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="recordDate"
            label="违规时间"
          >
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="points"
            label="扣分分值"
          >
          </el-table-column>
        </el-table>

        <div class="i-r-t">机构积分</div>
        <el-table stripe :data="obj.totalPoint && [obj.totalPoint] || []" border style="width: 100%">
          <el-table-column
            align="centet"
            header-align="center"
            prop="start"
            label="开始日期"
          ></el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="end"
            label="结束日期"
          >
          </el-table-column>
          <el-table-column
            align="centet"
            header-align="center"
            prop="totalPoint"
            label="总分"
          >
          </el-table-column>
        </el-table>
        <div class="i-r-t">机构网签地点</div>
        <div id="mapBox"></div>
      </div>
    </section>
    <main-footer></main-footer>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
import listLeft from "@/components/listLeft";
import { companyDetail, behavior } from "@/assets/api/company";
import { personList } from "@/assets/api/person";
export default {
  name: "App",
  components: {
    mainHeader,
    mainFooter,
    vueQr,
    listLeft,
  },

  data() {
    return {
      tableData: [
      ],
      id: this.$route.query.id,
      goodList: [],
      badList: [],
      obj: '',
      pList: [],
      mbCode: `${this.$globalData.serverUrl}/#/mCompanyDetail?id=${this.$route.query.id}`
    };
  },
  computed: {},
  mounted() {
   
    this.getDetail();
    this.getBehaviorGood();
    this.getBehaviorBad();
    this.getPersonList()
  },
  methods: {
    async getDetail() {
      const res = await companyDetail({ id: this.id });
      if (res && res.data && res.data.code == 200) {
        this.obj = res.data.data
        console.log(this.obj)
        this.initMap();
      }
    },
    handleCurrentChange() {},
    goRemark() {
      const jumpUrl = this.$router.resolve({ path: "/company/remark", query: { id: this.id } });
      window.open(jumpUrl.href, "_blank");
    },
    goDetail(item) {
      const jumpUrl = this.$router.resolve({ path: "/person/detail", query: { id: item.id } });
      window.open(jumpUrl.href, "_blank");
    },
    goStoreDetail(item) {
      const jumpUrl = this.$router.resolve({ path: "/store/detail", query: { id: item.id } });
      window.open(jumpUrl.href, "_blank");
    },
    initMap() {
      var map = new BMapGL.Map("mapBox");
      // 创建地图实例
      var point = new BMapGL.Point(this.obj.lng || 116.404, this.obj.lat || 39.915);
      map.centerAndZoom(point, 13);
      map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
      if (this.obj.lng && this.obj.lat) {
        let point = new BMapGL.Point(this.obj.lng, this.obj.lat);
        let marker = new BMapGL.Marker(point); // 创建标注
        map.addOverlay(marker); // 将标注添加到地图中
        // 创建点坐标
        let obj = {
            title: this.obj.name,
            message: this.obj.address,
            Longitude: this.obj.lng,
            latitude: this.obj.lat,
            width: 200, // 信息窗口宽度
            height: 100, // 信息窗口高度
        }
        var infoWindow = new BMapGL.InfoWindow(this.obj.address, obj); // 创建信息窗口对象
        map.openInfoWindow(infoWindow, point); //开启信息窗口
        marker.addEventListener("onmouseover", function () {
          map.openInfoWindow(infoWindow, point); //开启信息窗口
        });
      }
    },
    async getBehaviorGood() {
      const res = await behavior({
        companyId: this.id,
        good: 1,
      });
      if (res && res.data && res.data.code == 200) {
        this.goodList = res.data.rows || [];
      }
    },
    async getBehaviorBad() {
      const res = await behavior({
        companyId: this.id,
        good: 0,
      });
      if (res && res.data && res.data.code == 200) {
        this.badList = res.data.rows || [];
      }
    },
    async getPersonList() {
       const res = await personList({
        companyId: this.id,
      });
      if (res && res.data && res.data.code == 200) {
        this.pList = res.data.rows || [];
        console.log(this.pList)
      }
    }
  },
};
</script>

<style lang="less">
.detail-main-page {
  background: #fff;
  .list-clr {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    .page-right {
      width: 848px;
      .info-top {
        padding: 20px;
        border: 1px solid #eee;
        line-height: 26px;
        background: url("../../assets/img/info-bg.jpg") no-repeat top right;
        height: 192px;
        .info-title {
          font-size: 22px;
          font-weight: 700;
          line-height: 36px;
        }
        .info-desc {
          color: #999;
          margin-bottom: 10px;
          font-size: 14px;
        }
      }
      .info-bottom {
        line-height: 32px;
        padding: 20px;
        border: 1px solid #eee;
        border-top: none;
      }
      .i-r-t {
        font-size: 16px;
        margin: 20px 0;
      }
      .lab-item {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #555;
        font-size: 14px;
        margin-bottom: 6px;
        .lab-left {
          width: 126px;
          flex-shrink: 0;
        }
        .lab-right {
          flex: 1;
        }
      }
      .lab-row {
        display: flex;
        & > div {
          flex: 1;
        }
      }
    }

    .mg-t20 {
      margin-top: 20px;
    }
    #mapBox {
      width: 100%;
      height: 500px;
    }
  }
  .look-remark {
     color: #fff;
    background-color: #B1191A;
    font-size: 18px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 288px;
    height: 46px;
    cursor: pointer;
  }
  .BMap_bubble_title {
    width: 180px!important;
     white-space: nowrap!important;
    text-overflow: ellipsis!important;
    overflow: hidden!important;
    word-break: break-all!important;
  }
}
</style>